wbApp.directive('wbUniqueTenantValidator', ['$http', function ($http) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, elem, attr, ctrl) {

            scope.$watch(attr.ngModel, function (model) {
                if (model) {
                    $http({
                        method: 'POST',
                        url: '/Api/TenantRegistration/UniqueTenant',
                        data: { alias: model }
                    }).success(function (data, status, headers, cfg) {
                        ctrl.$setValidity('uniqueTenant', data.isValid);
                    }).error(function (data, status, headers, cfg) {
                        ctrl.$setValidity('uniqueTenant', false);
                    });
                } else {
                    ctrl.$setValidity('uniqueTenant', true);
                }
            });
        }
    };
}]);